const da_messages = require('./da/messages.json')

const DANISH_STRINGS = {
  translation: da_messages
}

export default DANISH_STRINGS
